import React from 'react';
import { Check } from 'lucide-react';
import { isValidIsraeliPhone } from '../utils/phoneValidation';

/**
 * Live green ✓ indicator that appears the moment the phone is valid.
 * Used across all phone inputs in the app for instant positive feedback.
 * Renders nothing if the phone is not yet a valid 10-digit Israeli number.
 */
const PhoneValid = ({ phone, className = '' }) => {
  if (!isValidIsraeliPhone(phone)) return null;
  return (
    <p
      role="status"
      data-testid="phone-valid-indicator"
      className={`mt-1.5 text-xs sm:text-[13px] text-green-600 font-semibold flex items-center gap-1 ${className}`}
    >
      <Check className="w-3.5 h-3.5" aria-hidden />
      <span>מספר תקין</span>
    </p>
  );
};

export default PhoneValid;
